// Estratto da index.ts (Phase 4a): rompe la dipendenza circolare
// index.ts <-> forms/edit.form.ts che sotto ES2020 causava un TDZ
// ("Cannot access 'supportedLanguages' before initialization").
export const supportedLanguages = [
	{
		label: 'Italiano',
		value: 'it'
	},
	{
		label: 'Inglese',
		value: 'en'
	},
	{
		label: 'Spagnolo',
		value: 'es'
	},
	{
		label: 'Francese',
		value: 'fr'
	},
	{
		label: 'Tedesco',
		value: 'de'
	},
	{
		label: 'Giapponese',
		value: 'ja'
	},
	{
		label: 'Cinese',
		value: 'zh'
	},
	{
		label: 'Russo',
		value: 'ru'
	},
	{
		label: 'Portoghese',
		value: 'pt'
	}
];
